import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box } from '@node-space/ui-components'
import { RewardsProduct } from 'types/rewards'
import { RewardCompoundedCalculator } from './components/RewardCompoundedCalculator'
import { RewardsAssets } from './components/RewardsAssets'

interface RewardsDiscoverProps {
  onSeeDetails: (currency: string) => void
  onAddWallet: () => void
  rewardsProducts: RewardsProduct[]
  isLoading: boolean
  hasNoWallets?: boolean
}

export const RewardsDiscover = ({
  onSeeDetails,
  onAddWallet,
  rewardsProducts,
  isLoading,
  hasNoWallets,
}: RewardsDiscoverProps) => {
  const { t } = useTranslation()

  return (
    <>
      <Box flexCol gapY={16} className="mb-6">
        {!hasNoWallets && (
          <h4 className="text-h4 text-foreground-prominent">{t('rewards.availableAssets')}</h4>
        )}
        <RewardsAssets
          assets={rewardsProducts}
          isLoading={isLoading}
          hasNoWallets={hasNoWallets}
          onSeeDetails={onSeeDetails}
          onAddWallet={onAddWallet}
        />
      </Box>

      <RewardCompoundedCalculator rewardsProducts={rewardsProducts} />
    </>
  )
}
